import apiService from "services/apiService";
import { AxiosResponse } from "axios";
import { NotificationBadgeResponse } from "./notificationInterface";

/**
 * Notification API access. Currently exposes the badge summary used to drive the
 * sidebar red-dots and the notification panel. Add read/dismiss endpoints here
 * as the backend grows.
 */
class NotificationManager {
  private url: string;
  constructor() {
    this.url = `/api/notifications`;
  }

  /** GET /api/notifications/badge — per-category unread/pending summary. */
  async getBadge(): Promise<AxiosResponse<NotificationBadgeResponse>> {
    return await apiService.get(`${this.url}/badge`);
  }

  /** PATCH /api/notifications/read-all — mark every notification as read. */
  async readAll(): Promise<AxiosResponse> {
    return await apiService.patch(`${this.url}/read-all`, {});
  }

  /**
   * PATCH /api/notifications/read?type=TYPE — mark all notifications of one type
   * as read. Used to auto-clear informational (non-action) notifications when the
   * user opens the related tab.
   */
  async readByType(type: string): Promise<AxiosResponse> {
    return await apiService.patch(`${this.url}/read?type=${encodeURIComponent(type)}`, {});
  }
}

const notificationManager = new NotificationManager();
export default notificationManager;
